/** @format */

import React from 'react';
import './styles.scss';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import ArticleLayout from 'components/ArticleLayout';
import Container from 'react-bootstrap/Container';

export default function ArticlePage2(props) {
  const text = props.t('lang_registration:article2');
  const { isMobileView } = props;

  return (
    <>
      <div className='main-container article2'>
        <Header {...props} />
        <div className='inner-container'>
          <Container>
            {/* Page content here */}
            <ArticleLayout
              text={text}
              isMobileView={isMobileView}
              banner={'images/image-article-page-2-1.png'}
              subIcon={'images/image-article-page-2-2.png'}
              subIcon1={'images/image-article-page-2-3.png'}
            />
          </Container>
        </div>

        <Footer {...props} />
      </div>
    </>
  );
}
